import React from "react";
import { Dropdown, DropdownButton } from "../../../../../../vendor";
import t from "../../../../helpers/t";
import { Biscuit } from "../../../../../utils";
import PricetariffValidFromsPanel from "../PricetariffvalidFromsPanel";
import { rbac } from "../../index";

const View = (props) => {
  const { dispatch, pricetariff, onRemovePricetariff, toggleValidFroms, index } = props;

  return (
    <>
      <div
        className=".inb-c-item inb-c-item row"
        key={pricetariff.id + "_" + index}
        id={"row_" + pricetariff.id}
      >
        <aside className="inb-c-item__actions">
          {rbac.hasPermission("write") && (
            <>
              <DropdownButton
                id="dropdown-basic-button"
                title="..."
                drop="right"
                menuAlign="right"
                bsPrefix="button round inb-toggle-contingent-dd hover"
              >
                <ul className="inb-dropdown__list">
                  {/*<li>
                        <Dropdown.Item href={"/pricetariffs/" + pricetariff.id}>
                            <i className="fi fi-wrench"></i>{t('edit', null, ' capital')}
                        </Dropdown.Item>
                      </li>*/}
                  <li>
                    <Dropdown.Item href="#" onClick={() => onRemovePricetariff(pricetariff)}>
                      <i className="fi fi-trash"></i>
                      {t("remove", null, " capital")}
                    </Dropdown.Item>
                  </li>
                </ul>
              </DropdownButton>
            </>
          )}

          <button
            className={
              "button round inb-toggle-details inb-toggle-details-" + Biscuit.get("user.client_id")
            }
            type="button"
            title={t("toggle_${a}", { a: t("pricetariff_valid_froms") }, "capital")}
            data-inb-toggle={"pricetariffs-panel-" + pricetariff.id}
            onClick={(e) => toggleValidFroms(e, pricetariff.id)}
            id={"btn_pt_" + pricetariff.id}
          >
            <i className="fi fi-list-thumbnails"></i>
            {pricetariff.pricetariff_valid_froms.length >= 1 && (
              <div className="badge primary reservations-count">
                {pricetariff.pricetariff_valid_froms.length}
              </div>
            )}
          </button>
        </aside>

        <div className="medium-5 small-5 column inb-order-big" title="Bezeichnung">
          {pricetariff.name}
        </div>
        <div className="medium-6 small-5 column" title="Beschreibung">
          {pricetariff.description}
        </div>
        {/*<div className="medium-2 small-3 medium-offset-0 column padding-1" title="Typ">
                  {t(type,null,'capital')}
                </div>
                <div className="medium-1 small-3 column" title="Anzahl Preise">
                  {count}
                </div>
                <div className="medium-2 small-3 medium-offset-0 column padding-1" title="Gültig">
                  {moment(pricetariff.begin).format('DD.MM.YY, HH:mm')}
                </div>*/}

        <PricetariffValidFromsPanel
          validFroms={pricetariff.pricetariff_valid_froms}
          dispatch={dispatch}
          pricetariff={pricetariff}
        />

        <div className="inb-contingent-progress">
          <div
            className={"progress beautify beautify-" + Biscuit.get("user.client_id")}
            role="progressbar"
            tabIndex="0"
            aria-valuenow="50"
            aria-valuemin="0"
            aria-valuetext="50 percent"
            aria-valuemax="100"
          >
            <div className="progress-bars"></div>
            <p className="progress-meter-text">
              {t("${a}_prices", { a: pricetariff.count_of_prices }, "capital")}
              <i className="hide set-resources-amount fi fi-pencil" data-inb-action-link="edit"></i>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default View;
